/* eslint-disable sonarjs/new-cap */
import { CancelToken } from 'axios';
import type { ExcelUploadedFile, Inventory, PaginatedNext } from '../types';
import { ApiRepository } from './main repository/api.repository';
import { PaginateOptions } from './type';

// eslint-disable-next-line @typescript-eslint/no-namespace
export namespace InventoryService {
  const BASE_API = `${window.globalConfiguration.api.base}/v1/inventory`;

  export const findPaginated = async ({ page, limit, filters, sorting }: PaginateOptions, cancelToken: CancelToken) => {
    return ApiRepository.Core().get<PaginatedNext<Inventory>>(
      `${BASE_API}?page=${page}&limit=${limit}${filters.join('')}${sorting}`,
      {},
      { cancelToken }
    );
  };

  export const excelDownload = async ({
    filters,
    sendMail,
  }: Pick<PaginateOptions, 'filters'> & { sendMail: boolean }) => {
    return ApiRepository.Core().get<ExcelUploadedFile>(`${BASE_API}/excel?${filters.join('')}`, { sendMail });
  };
}
